import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import {
  COMMUNITY_APPS_RESOURCE,
  COMMUNITY_APP_RESOURCE,
  UPDATE_COMMUNITY_APP_RESOURCE,
} from '../../constants';
import { createErrorMessage } from '../../../app/helpers/createErrorMessage';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: UPDATE_COMMUNITY_APP_RESOURCE,
      method: 'put',
      request: (id, body, callback, t) => ({
        url: apiRoutes.communityApps(id),
        body,
        meta: {
          callback,
          updateOtherList: {
            resource: COMMUNITY_APPS_RESOURCE,
            idProp: 'id',
            id,
            valuesModifier: values => ({ ...values, app: { ...values.appDetails } }),
          },
          setOther: {
            resource: COMMUNITY_APP_RESOURCE,
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'updateCommunityAppFailed'),
            onSuccessMessage: t('updateCommunityAppSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);
